<template>
	<div>
		<case-form :schema="schemaShared" class="mt6" />

		<div class="xs-12 fs4 fw7 mb2 mt6">上年度</div>
		<case-form :schema="schemaCurrentYear" />

		<div class="xs-12 fs4 fw7 mb2 mt6">本年度</div>
		<case-form :schema="schemaLastYear" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schemaShared() {
			return [
				{
					label: `收入表是否与别人共有、共享？`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementIsSharedCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementIsSharedCN`
						},
						createOptions: {
							type: `incomeStatementIsSharedCN`,
							dataType: "boolean"
						}
					}
				},
				{
					component: "html",
					props: {
						content: `<div class='fs4 fw7 lh125'>如选择"是"，请完成以下问题：</div>`
					},
					bindTo: ""
				},
				{
					label: `共有、共享人士（说明关系）：`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSharedWithCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSharedWithCN`
						},
						createOptions: {
							type: `incomeStatementSharedWithCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `比例（%）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSharedRatioCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSharedRatioCN`
						},
						createOptions: {
							type: `incomeStatementSharedRatioCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaCurrentYear() {
			return [
				{
					label: `日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDateCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryDateCN`
						},
						createOptions: {
							type: `incomeStatementSalaryDateCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `薪资 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSalaryCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryCN`
						},
						createOptions: {
							type: `incomeStatementSalaryCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `奖金 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementBonusCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementBonusCN`
						},
						createOptions: {
							type: `incomeStatementBonusCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `利息 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementInterestCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementInterestCN`
						},
						createOptions: {
							type: `incomeStatementInterestCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `分红 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDividendsCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementDividendsCN`
						},
						createOptions: {
							type: `incomeStatementDividendsCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `租金 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementRentCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementRentCN`
						},
						createOptions: {
							type: `incomeStatementRentCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `其他（请说明）(美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementOtherCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementOtherCN`
						},
						createOptions: {
							type: `incomeStatementOtherCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `总收入 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementTotalCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementTotalCN`
						},
						createOptions: {
							type: `incomeStatementTotalCN`,
							dataType: "number"
						}
					}
				}
			]
		},

		schemaLastYear() {
			return [
				{
					label: `日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDateLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryDateLastYearCN`
						},
						createOptions: {
							type: `incomeStatementSalaryDateLastYearCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `奖金 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementSalaryLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementSalaryLastYearCN`
						},
						createOptions: {
							type: `incomeStatementSalaryLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `奖金 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementBonusLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementBonusLastYearCN`
						},
						createOptions: {
							type: `incomeStatementBonusLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `利息 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementInterestLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementInterestLastYearCN`
						},
						createOptions: {
							type: `incomeStatementInterestLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `分红 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementDividendsLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementDividendsLastYearCN`
						},
						createOptions: {
							type: `incomeStatementDividendsLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `租金 (美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementRentLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementRentLastYearCN`
						},
						createOptions: {
							type: `incomeStatementRentLastYearCN`,
							dataType: "number"
						}
					}
				},
				{
					label: `其他（请说明）(美元)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0incomeStatementOtherLastYearCN`,
					props: {
						suggest: {
							typeIncludes: `incomeStatementOtherLastYearCN`
						},
						createOptions: {
							type: `incomeStatementOtherLastYearCN`,
							dataType: "number"
						}
					}
				}
			]
		}
	}
}
</script>
